import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import notify from 'devextreme/ui/notify';
import DevExpress from 'devextreme';

let self: DynamicLayoutGridComponent = null;

@Component({
  selector: 'app-dynamic-layout-grid',
  templateUrl: './dynamic-layout-grid.component.html',
  styleUrls: ['./dynamic-layout-grid.component.css']
})
export class DynamicLayoutGridComponent {

  _grid: DevExpress.ui.dxDataGrid;
  _deleteFunction: any = null;
  _dataSource: any[];
  _columns: any[] = null;
  _summary: any = null;
;
  _searchPanel: any;
  _selection: any;
  _suspendDeleting: boolean;
  _height: number;
  _autoHeight: boolean;
  _heightIsSet: boolean;
  _paging: any;
  _scrolling: any;
  _columnAutoWidth: any;
  _width: number;

  _hoverStateEnabled: boolean;
  _export: any;

  allowDeleting: boolean = false;
  private _tile: any = null;
  @Input() set dynamicLayoutTile(tile) {
    this._tile = tile;
    this._tile.updateTheGrid = this._updateGrid;
  }
  @Input() showHeaderFilter = true;
  @Input() showGroupPanel = true;

  @Output() onRowClick = new EventEmitter<void>();
  @Output() onRowRemoving = new EventEmitter<void>();
  @Output() onSelectionChanged = new EventEmitter<void>();
  @Output() onBookmarkClick = new EventEmitter<void>();

  _dynamicLayoutId: number;
  _dynamicLayoutDataSource: (dynamicLayoutId: number) => Observable<any> = null;

  constructor() {
    self = this;
    this._dynamicLayoutDataSource = null;
    this._autoHeight = false;
    this._paging = { enabled: true, pageSize: 1000 };
    this._heightIsSet = false;
    this._selection = { mode: 'none' };
    this.cellTemplates = null;
    this._export = { enabled: false };
  }

  _updateGrid() {
    if (self._dynamicLayoutDataSource != null) {
      self._dynamicLayoutDataSource(self._dynamicLayoutId).subscribe((result: any) => {
        if (result.IsSuccess) {
          self.dataSource = result.Data.DataRows;
        }
        else {
          notify(result.ErrorMessage, "error", 3000);
        }
      }, error => {
        notify("An error occurred", "error", 3000);
      });
    }
  }

  _onInitialized(e: any): void {
    this._grid = e.component;
    this._heightIsSet = false;

    if (this._dynamicLayoutDataSource != null) {
      this._dynamicLayoutDataSource(this._dynamicLayoutId).subscribe((result: any) => {
        if (result.IsSuccess) {
          
          if (this._columns == null) {
            this._columns = this.convertTheColumns(result.Data.Tiles[0].Columns);

            let s = result.Data.Tiles[0].GridSettings;
            if (typeof (s) !== "undefined" && s != null) {
              if (typeof (s.export) !== "undefined") {
                this._export = s.export;
              }
              if (typeof (s.paging) !== "undefined") {
                this._paging = s.paging;
              }
              if (typeof (s.scrolling) !== "undefined") {
                this._scrolling = s.scrolling;
              }
              if (typeof (s.columnAutoWidth) !== "undefined") {
                this._columnAutoWidth = s.columnAutoWidth;
              }
              if (typeof (s.searchPanel) !== "undefined") {
                this._searchPanel = s.searchPanel;
              }
              if (typeof (s.summary) !== "undefined") {
                if (s.summary.totalItems && s.summary.totalItems[0] && !s.summary.totalItems[0].valueFormat) {
                  s.summary.totalItems[0].valueFormat = { type: "fixedPoint", precision: 2 };
                }
                this._summary = s.summary;
              }

              //autoHeight not a true grid property
              if (typeof (s.autoHeight) !== "undefined") {
                this._autoHeight = s.autoHeight;
              }
            }
          }
          this.dataSource = result.Data.DataRows;
        }
        else {
          notify(result.ErrorMessage, "error", 3000);
        }
      }, error => {
        notify("An error occurred", "error", 3000);
      });
    }
  }

  _onContentReady(e: any): void {
    this._grid = e.component;
    if (!this._heightIsSet && this._autoHeight) {
      this._heightIsSet = true;
      const cr = e.element.getClientRects();
      if (cr != null && cr.length > 0) {
        this._height = window.innerHeight - 40;
        this._width = cr[0].width;
      }
    }
  }

  _onBookmarkClick(e: any, data: any) {
    e.event.stopPropagation();
    this.onBookmarkClick.emit(data);
  }

  @Input()
  set dataSource(dynamicDataRows: any[]) {
    const ds: any[] = [];
    for (let i = 0; i < dynamicDataRows.length; i++) {
      const data = dynamicDataRows[i].RowTiles[0];//hardcoded to be just ONE tile per row for grid
      const d = { MandatoryValues: data.MandatoryValues };
      for (let j = 0; j < data.Values.length; j++) {
        d["" + data.Values[j].ColumnId] = data.Values[j].Value;
      }
      ds.push(d);
    }
    this._dataSource = ds;
  }

  private convertTheColumns(dynamicColumns): any {
    const cols = [];
    if (this.onBookmarkClick.observers !== null && this.onBookmarkClick.observers.length > 0) {
      cols.push({
        cellTemplate: "bookmarkCellTemplate",
        width: 50
      });
    }
    if (dynamicColumns != null) {
      for (let i = 0; i < dynamicColumns.length; i++) {
        let dataType = "string";
        let format = undefined;
        let width = undefined;
        let groupIndex = undefined;
        if (dynamicColumns[i].Width > 0) {
          width = dynamicColumns[i].Width;
        }
        if (dynamicColumns[i].GroupBySequence >= 0) {
          groupIndex = dynamicColumns[i].GroupBySequence;
        }
        switch (dynamicColumns[i].ColumnDataType) {
          case "int":
          case "double":
            dataType = "number";
            if (dynamicColumns[i].GridColumnFormat !== null) {
              format = dynamicColumns[i].GridColumnFormat;
            }
            break;
        }

        cols.push({
          dataField: "" + dynamicColumns[i].ColumnId,
          format: format,
          caption: dynamicColumns[i].Label,
          dataType: dataType,
          groupIndex: groupIndex,
          width: width,
          visible: dynamicColumns[i].DisplayMode_Visible,
          cellTemplate: this.getCellTemplate(dynamicColumns[i].Name)
        });
      }
    }
    return cols;
  }

  @Input()
  set columns(dynamicColumns: any[]) {
    const cols = this.convertTheColumns(dynamicColumns);
    this._columns = cols;
  }

  @Input()
  set searchPanel(sp: any) {
    this._searchPanel = sp;
  }

  @Input()
  set selection(s: any) {
    this._selection = s;
  }


  @Input()
  set dynamicLayoutId(dlid: number) {
    this._dynamicLayoutId = dlid;
  }

  @Input()
  set dynamicLayoutDataSource(ds: (dynamicLayoutId: number) => Observable<any>) {
    this._dynamicLayoutDataSource = ds;
  }

  @Input()
  set autoHeight(ah: boolean) {
    this._autoHeight = ah;
  }

  @Input()
  set hoverStateEnabled(v: boolean) {
    this._hoverStateEnabled = v;
  }

  @Input()
  set paging(v: any) {
    this._paging = v;
  }

  @Input()
  set height(v: any) {
    this._height = v;
  }

  @Input() cellTemplates: any[];

  @Input()
  set export(v: any) {
    this._export = v;
  }

  private getCellTemplate(columnName: string) {
    let cb = undefined;
    if (this.cellTemplates != null) {
      for (let i = 0; i < this.cellTemplates.length; i++) {
        if (this.cellTemplates[i].columnName === columnName) {
          cb = this.cellTemplates[i].callback;
          break;
        }
      }
    }
    return cb;
  }
}
